<template>
    <div class="share-links double-column-simple">
        <span class="ad">
            <a
                v-for="(shareLink, index) in shareLinks"
                :key="shareLink.id + '-' + index"
                class="iconfont"
                :href="shareLink.url"
                :class="shareLink.icon"
                :aria-label="shareLink.socialNetwork"
                target="_blank"
                rel="noopener noreferrer"
            ></a>
        </span>
    </div>
</template>

<script>
import { ICON_MAP_WITH_ROUND as SPECIAL_ICON_MAP } from '../icon-map';
import util from '@/common/util.js'
export default {
    props: {
        socialNetworks: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        shareLinks() {
            let list = util.deepClone(this.socialNetworks);
            const shareLinks = list.filter(item => {
                item.icon =
                    SPECIAL_ICON_MAP[item.socialNetwork] ||
                    'icon-' + item.socialNetwork + '-round';
                return !!item.socialNetwork && !!item.url;
            });
            return shareLinks;
        }
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.share-links.double-column-simple {
    .ad {
        font-size: 0;
        .iconfont {
            display: inline-block;
            vertical-align: top;
            margin-bottom: 0;
            margin-top: 10px;
            width: 28px;
            height: 28px;
            line-height: 28px;
            border-radius: 50%;
            overflow: hidden;
            font-size: 30px;
            text-align: center;
            color: #ffffff;
            cursor: pointer;
            margin-left: 20px;
            @include media-800 {
                margin-left: 0;
                margin-top: 10px;
                margin-right: 20px;
            }
            @include media-600 {
                margin-right: 20px;
            }
        }
        .icon-youtube-fill {
            color: #dd332c;
        }
        .icon-pinterest-round {
            color: #cd2324;
        }
        .icon-angellist-round {
            color: #000;
            font-size: 32px;
        }
        .icon-google-plus-round {
            color: #d13e2f;
        }
        .icon-agent-whatsapp {
            background-color: #00d41b;
            font-size: 15px;
        }
        .icon-facebook-round {
            color: #4b67a0;
        }
        .icon-linkedin-round {
            color: #007ab9;
        }
        .icon-newtwitter-round {
            color: #53a9ea;
        }
        .icon-zillow-round {
            color: #0071e8;
        }
        .icon-yelp-round {
            color: #d84132;
        }
        .instagram-logo {
            background-image: url('//static.chimeroi.com/site/images/logo/instagram.png');
            background-repeat: no-repeat;
            background-size: 28px auto;
        }
        .snapchat-logo {
            background-image: url('//static.chimeroi.com/site/images/about/snapchat-44.png');
            background-repeat: no-repeat;
            background-size: 28px auto;
        }
        .icon-redfin-round {
            color: #c11011;
        }
    }
}
</style>
